export var CustomContentPageEnum;
(function (CustomContentPageEnum) {
    CustomContentPageEnum["Results"] = "results";
    CustomContentPageEnum["Seats"] = "seats";
    CustomContentPageEnum["Meal"] = "meal";
    CustomContentPageEnum["Baggage"] = "baggage";
    CustomContentPageEnum["Order"] = "order";
    CustomContentPageEnum["Payment"] = "payment";
})(CustomContentPageEnum || (CustomContentPageEnum = {}));
